import { render, staticRenderFns } from "./HomeworkEdit.vue?vue&type=template&id=7089d828&scoped=true&"
import script from "./HomeworkEdit.vue?vue&type=script&lang=js&"
export * from "./HomeworkEdit.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkEdit.vue?vue&type=style&index=0&id=7089d828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089d828",
  null
  
)

export default component.exports